import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = ["category", "list", "site"];

    SITES = [];

    connect()
    {
        if(this.siteTargets.length == 0) return;

        this.SITES = this.siteTargets.map(target => target.cloneNode(true));
        
        this.categoryTargets.forEach(category => category.addEventListener("click", e =>
        {
            this.categoryTargets.forEach(cat => cat.classList.remove("selected"));
            category.classList.add("selected");


            let filtered = category.dataset["code"] == "All" ? this.SITES : 
                            this.SITES.filter(site => category.dataset["code"].toLowerCase() == site.dataset["code"].toLowerCase() )

            // setTimeout(() => {

                this.listTarget.firstElementChild.classList.add("hidden");
                
                let div = document.createElement("div");
                div.append(...filtered);
                div.classList.add("list", "mx-4");

                this.listTarget.replaceChild(div, this.listTarget.firstElementChild)

            // }, 50);
            

            // this.listTarget.firstElementChild.classList.add("hidden");
            // this.listTarget.firstElementChild.innerHTML = "";
            // this.listTarget.firstElementChild.append(...filtered);
            // this.listTarget.firstElementChild.classList.remove("hidden");

        }))
    }
}